import React from 'react';
import { Handle, Position } from 'reactflow';
import { useNodeTheme } from './NodeTheme';

// Fila de "puerto de salida" (estilo n8n): etiqueta a la izquierda + punto de
// conexión (Handle) sobre el borde derecho de la tarjeta. El Handle se posiciona
// hacia adentro (right: 10px) porque la tarjeta usa overflow:hidden y recortaría
// un handle que sobresalga; así el punto queda visible y es el conector real.
const NodeOutputRow = ({ label, color, handleId, isConnectable }) => {
  const theme = useNodeTheme();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '6px 26px 6px 14px',
        position: 'relative',
      }}
    >
      <span
        style={{
          fontSize: '11px',
          color: theme.textPrimary,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1,
          minWidth: 0,
        }}
        title={label}
      >
        {label}
      </span>
      <Handle
        type="source"
        position={Position.Right}
        id={handleId}
        isConnectable={isConnectable}
        style={{
          backgroundColor: color,
          width: '9px',
          height: '9px',
          border: `2px solid ${theme.cardBg}`,
          right: '10px',
        }}
      />
    </div>
  );
};

export const NodeStaticRow = ({ icon: Icon, label, color }) => {
  const theme = useNodeTheme();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '6px 14px',
      }}
    >
      {Icon && <Icon style={{ fontSize: '12px', color, flexShrink: 0 }} />}
      <span
        style={{
          fontSize: '11px',
          color: theme.textPrimary,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1,
          minWidth: 0,
        }}
        title={label}
      >
        {label}
      </span>
    </div>
  );
};

// Contenedor de las filas de puerto: divisor superior + espaciado. Se renderiza
// a nivel de tarjeta (fuera del padding del cuerpo), por eso las filas ya llegan
// a los bordes sin necesidad de márgenes negativos.
export const NodeOutputGroup = ({ children }) => {
  const theme = useNodeTheme();

  return (
    <div>
      <div style={{ height: '1px', backgroundColor: theme.border }} />
      <div style={{ padding: '4px 0 6px 0' }}>{children}</div>
    </div>
  );
};

export default NodeOutputRow;
